var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5497 4.25052C14.7059 4.40673 14.7059 4.65999 14.5497 4.8162L7.42435 11.9415C6.87769 12.4882 5.99139 12.4883 5.44463 11.9417L1.4507 7.94918C1.29447 7.79299 1.29442 7.53973 1.4506 7.38349C1.60679 7.22725 1.86005 7.22721 2.01629 7.38339L6.01021 11.3759C6.24454 11.6102 6.62438 11.6101 6.85867 11.3758L13.984 4.25052C14.1402 4.09431 14.3935 4.09431 14.5497 4.25052Z",
    fill: "#554596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectConfirm);
export default __webpack_public_path__ + "static/media/selectConfirm.57aae7d6cfd76a90fdf0b24c0cfaf351.svg";
export { ForwardRef as ReactComponent };